import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Copyleft: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['path', { d: 'M9 9.4a4 4 0 1 1 0 5.25' }],
  ],
];

export default Copyleft;
